import { Col, Row, Typography } from 'antd';
import classNames from 'classnames';
import { map } from 'lodash-es';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import { cssVariables } from '../../../styles/cssVariables';
import { DateTimeFormatNumericNoYear } from '../../../utils/dateFormatting';
import { TwoLinesSeparator } from '../../../components/layout/layoutElements';
import { useQuoteStyles } from '../../../styles/quote.styles';
import { NoValue } from './components/NoValue';
import {
  AirlineLogo,
  UnknownAirlineLogoOrderBadge,
} from '../../../components/flights/AirlineLogos';
import { DeliveryStatus } from './QuoteDeliveryStatus';
import { useQuoteDeliveryStatusStyles } from './QuoteDeliveryStatus.styles';
import { useQuoteFlightItineraryStyles } from './QuoteFlightItinerary.styles';

export function QuoteFlightItinerary({ flights }) {
  const { styles: sharedStyles } = useQuoteStyles();
  const { styles } = useQuoteFlightItineraryStyles();
  const { styles: deliveryStatusStyles } = useQuoteDeliveryStatusStyles();
  return (
    <div>
      <TwoLinesSeparator
        style={{
          marginTop: cssVariables.spaceLg,
          marginBottom: cssVariables.spaceSm,
        }}
      />
      <Row>
        <Typography.Title
          level={3}
          className={classNames(
            'text-uppercase',
            sharedStyles.shipmentInfoTitle
          )}
        >
          <FormattedMessage id="book.newQuote.flightItinerary" />
        </Typography.Title>
      </Row>
      {map(flights, (flight, index) => (
        <div key={flight} className={styles.itineraryCard}>
          <Row justify="space-between">
            <Col span={24}>
              <TwoLinesSeparator />
            </Col>
            <Col md={11} sm={24}>
              <DeliveryStatus className="hide-sm-and-smaller" />
              <Row gutter={[8, 8]}>
                <Col span={2} className={styles.airlineLogo}>
                  <AirlineLogo
                    airline={flight.airline}
                    fallback={
                      <UnknownAirlineLogoOrderBadge index={index + 1} />
                    }
                  />
                </Col>
                {[
                  { label: 'airline', value: flight.airline },
                  { label: 'flight', value: flight.flightNumber },
                  { label: 'origin', value: flight.originAirportCode },
                  {
                    label: 'destination',
                    value: flight.destinationAirportCode,
                  },
                ].map(({ label, value }) => (
                  <Col span={5} key={label}>
                    <Typography.Text
                      className={deliveryStatusStyles.itineraryLabel}
                    >
                      <FormattedMessage
                        id={`book.quote.flightInformation.${label}`}
                      />
                    </Typography.Text>
                    <div className={styles.itineraryValue}>{value}</div>
                  </Col>
                ))}
              </Row>
            </Col>

            <Col md={1} className="flex-center hide-sm-and-smaller">
              <hr className={styles.verticalSeparator} />
            </Col>

            {/* Schedule Details */}
            <Col md={11} sm={24} className={styles.flightItinerarySchedules}>
              <Row gutter={[8, 8]}>
                <Col xs={9} md={8}>
                  <Row style={{ height: '24px' }}>
                    <DeliveryStatus className="hide-md-and-bigger" />
                  </Row>
                  <Row>
                    <Typography.Text
                      className={deliveryStatusStyles.itineraryLabelBold}
                    >
                      <FormattedMessage id="book.quote.flightInformation.scheduled" />
                    </Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Text
                      className={deliveryStatusStyles.itineraryLabelBold}
                    >
                      <FormattedMessage id="book.quote.flightInformation.estimated" />
                    </Typography.Text>
                  </Row>
                </Col>
                {[
                  {
                    label: 'depart',
                    start:
                      flight.departure.scheduled || flight.departure.estimated,
                    end: flight.departure.estimated,
                  },
                  {
                    label: 'arrive',
                    start: flight.arrival.scheduled || flight.arrival.estimated,
                    end: flight.arrival.estimated,
                  },
                ].map(({ label, start, end }, idx) => (
                  <Col span={idx === 0 ? 8 : 6} key={label}>
                    <Typography.Text
                      className={deliveryStatusStyles.itineraryLabel}
                    >
                      <FormattedMessage
                        id={`book.quote.flightInformation.${label}`}
                      />
                    </Typography.Text>

                    <div className={styles.itineraryValue}>
                      {start ? (
                        <DateTimeFormatNumericNoYear value={moment(start)} />
                      ) : (
                        <NoValue />
                      )}
                    </div>

                    <div className={styles.itineraryValue}>
                      {end ? (
                        <DateTimeFormatNumericNoYear value={moment(end)} />
                      ) : (
                        <NoValue />
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>
      ))}
      <Row>
        <Col span={24}>
          <TwoLinesSeparator />
        </Col>
      </Row>
    </div>
  );
}
